import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { Star, AlertTriangle, MessageSquare, BarChart2, TrendingUp, Shield } from 'lucide-react';
/*
  SEO SPECIFICATION:
  Title: AI Reputation Manager — Reviews Monitored and Responded to Automatically
  Meta Desc: MISTR monitors every review platform, flags negative feedback, and responds automatically in your brand voice. Protect and grow your reputation on autopilot.
  Primary KW: AI reputation management for small business
*/
export function ReputationManager() {
  return <FeaturePageLayout seoTitle="Reputation Manager — Reviews on Autopilot | MindStream.ing" seoDesc="MISTR monitors every review platform, flags negative feedback, and responds automatically in your brand voice. Protect and grow your reputation on autopilot." heroEyebrow="REPUTATION MANAGER" heroTitle={<>
          Your Reputation on <span className="text-gradient" data-id="element-2222">Autopilot.</span>
        </>} heroDesc="MR monitors every review platform, flags negative feedback, and responds automatically in your brand voice." heroImage="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" howItWorks={{
    title: 'How It Works',
    steps: [{
      title: 'Monitor',
      desc: 'MR constantly monitors all major review platforms for new feedback.'
    }, {
      title: 'Analyze',
      desc: 'Negative reviews are flagged instantly for your attention.'
    }, {
      title: 'Respond',
      desc: 'Responses are drafted and sent automatically in your brand voice.'
    }]
  }} features={{
    cards: [{
      icon: <Shield size={24} data-id="element-2223" />,
      title: 'Multi-Platform Monitoring',
      desc: 'Watches Google, Yelp, Facebook, and industry-specific sites 24/7.'
    }, {
      icon: <AlertTriangle size={24} data-id="element-2224" />,
      title: 'Instant Negative Alerts',
      desc: 'Pings you immediately when a sub-3-star review is posted.'
    }, {
      icon: <MessageSquare size={24} data-id="element-2225" />,
      title: 'Auto-Responses',
      desc: 'Thanks positive reviewers and de-escalates negative ones in your voice.'
    }, {
      icon: <BarChart2 size={24} data-id="element-2226" />,
      title: 'Review Analytics',
      desc: 'Tracks your average rating and review volume over time.'
    }, {
      icon: <TrendingUp size={24} data-id="element-2227" />,
      title: 'Sentiment Tracking',
      desc: 'Analyzes the text of reviews to identify common complaints or praises.'
    }]
  }} data-id="element-2221" />;
}